<app-page-header [data]="header()" [fullPath]="fullPath()"></app-page-header>
<div class="content-standard-spacer"></div>
@for(element of contentElements(); track $index) {
<ng-container *ngComponentOutlet="element?.component; inputs: element?.inputs" />
}
<app-page-footer [data]="footer()"></app-page-footer>